import { render, staticRenderFns } from "./IrrRequestDataComponent.vue?vue&type=template&id=dffeccea&scoped=true"
import script from "./IrrRequestDataComponent.vue?vue&type=script&lang=js"
export * from "./IrrRequestDataComponent.vue?vue&type=script&lang=js"
import style0 from "./IrrRequestDataComponent.vue?vue&type=style&index=0&id=dffeccea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffeccea",
  null
  
)

export default component.exports